const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const apiUrl = (path) => `${API_BASE_URL}/api${path}`;

const parseJsonResponse = async (response) => {
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const message = data?.detail || data?.message || 'Request failed';
    throw new Error(message);
  }

  return data;
};

export const searchFaces = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(apiUrl('/search'), {
    method: 'POST',
    body: formData,
  });

  return parseJsonResponse(response);
};

export const submitFeedback = async ({ name, email, message }) => {
  const response = await fetch(apiUrl('/feedback'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      email: email || null,
      message,
    }),
  });

  return parseJsonResponse(response);
};
